import { defineCommands, type CommandsOf, applyEntityDataChanges } from '../../commands/defineCommands';
import type { CanvasStoreContext } from '../../types';
import type { ImageData as CanvasImageData } from '../../entityTypes';

export const imageCommands = defineCommands({
  'image.updateData': (ctx: CanvasStoreContext, event: {
    entityId: string; dataChanges: Partial<CanvasImageData>;
  }): CanvasStoreContext => applyEntityDataChanges(ctx, event.entityId, event.dataChanges),
});

export type ImageCommand = CommandsOf<typeof imageCommands>;
